import React from "react"
import FadeIn from "../general/fadein.tsx"
import FadeInTop from "../general/fadeintop.tsx"
import centerstage from "../../images/centerstage/centerstage-big.png"
import robot from "../../images/centerstage/robot.png"
import backdrop from "../../images/centerstage/backdrop.png"
import teamprop from "../../images/centerstage/teamprop.png"
import pixel from "../../images/centerstage/pixel.png"
import successfulauto from "../../images/centerstage/successfulauto.png"
import flowchart from "../../images/centerstage/autonomousflowchart.png"
import scoredpixels from "../../images/centerstage/scoredpixels.png"
import dronelauncher from "../../images/centerstage/dronelauncher.png"
import rigging from "../../images/centerstage/rigging.png"
import portfolio from "../../images/centerstage/portfolio.pdf"
import statemachine from "../../images/centerstage/statemachine.png"
import lowpassfilter from "../../images/centerstage/lowpassfilter.png"
import meepmeep from "../../images/centerstage/meepmeep.png"

function CenterStage() {

    const transition = {
        transition: ".3s"
    }
    const brief_description = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">This Season's Game</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">An FTC game is divided into three stages. Autonomous where the robot runs itself. Tele-Op where two human drivers control the robot. And Endgame where the robot gets additional tasks that are worth lots of points.
            <br></br><br></br>Below are two important terms for this seasons game.
        </p>
        <div className="flex flex-row ">
            <div className="flex flex-col mr-4">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Pixel</p>
                <img
                    className=" h-36 rounded-md object-contain object-center"
                    src={pixel}
                    alt="Pixel"
                />
            </div>
            <div className="flex flex-col">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Backdrop</p>
                <img
                    className=" rounded-md object-contain object-center"
                    src={backdrop}
                    alt="Backdrop"
                />
            </div>
        </div>
    </div>)
    const robot_picture = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-5 text-center font-semibold">Our Robot</p>
        <img
            className="rounded-md object-contain object-center"
            src={robot}
            alt="Robot"
        />
    </div>)
    const autonomous_section = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Autonomous</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">At the start of Autonomous, our robot identifies our Team Prop which instructs the code which of the three paths to follow. <br></br>
            <br></br>If the autonomous is successful, the field will appear like the image on the bottom. The yellow pixel will be placed above one of three april tags on the purple pixel will end up on the Spike Mark.</p>
        <div className="flex flex-row ">
            <div className="flex flex-col mr-4">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Team Prop</p>
                <img
                    className=" h-36 rounded-md object-contain object-center"
                    src={teamprop}
                    alt="Team Prop"
                />
            </div>
            <div className="flex flex-col">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Successful Autonomous</p>
                <img
                    className=" rounded-md object-contain object-center"
                    src={successfulauto}
                    alt="Successful Autonomous"
                />
            </div>
        </div>
    </div>);
    const autonomous_flow_chart = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-5 text-center font-semibold">Autonomous Flow Chart</p>
        <img
            className=" h-36 rounded-md object-contain object-center"
            src={flowchart}
            alt="Flow Chart"
        />
    </div>)

    const tele_op_description = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Tele-Op</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">During the Tele-Op period, the human drivers manuever the robot to collect pixels around the field and place them on the backdrop. </p>
        <div className="flex flex-row ">
            <div className="flex flex-col ">
                <p className="text-2xl w-100 pt-10 text-center font-semibold">Scored Pixels</p>
                <img
                    className=" rounded-md object-contain object-center"
                    src={scoredpixels}
                    alt="Scored Pixels"
                />
            </div>
        </div>
    </div>)
    const endgame_description = (<div>
        <div className="flex flex-col items-center ">
            <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Endgame</p>

            <p className="text-xl w-4/5 pt-4 text-left font-light">During the Endgame period, there are two new tasks introduced. Launch a paper airplane and hang the robot in the air. </p>

        </div>
        <div className="flex flex-row pl-16">
            <div className="flex flex-col">
                <div className="flex flex-row pt-5">
                    <div>
                        <p className="text-2xl pt-5 font-semibold">Drone Launch</p>
                        <p className="text-xl font-light">We launch our drone using springs. The springs are held back with a rack and pinion to prevent misfires.</p>
                    </div>
                    <img
                        className=" rounded-md object-contain object-center"
                        src={dronelauncher}
                        alt="Drone Launcher"
                    />
                </div>
                <div className="flex flex-row pt-5">
                    <div>
                        <p className="text-2xl pt-5 font-semibold">Rigging</p>
                        <p className="text-xl font-light">We rig our robot by pushing off the ground with wheels off the back of the robot and using hooks to suspend the robot off the truss.</p>
                    </div>
                    <img
                        className=" rounded-md object-contain object-center"
                        src={rigging}
                        alt="Rigging"
                    />
                </div>
            </div>
        </div>

    </div>)
    const coding_description = (<div className="flex flex-col items-center">
        <p className="text-2xl w-4/5 pt-4 text-center font-semibold">Coding</p>

        <p className="text-xl w-4/5 pt-4 text-left font-light">In order for the code to be efficient and usable, I used a Finite State Machine to manage different states of the robot at the same time. This way the robot can drive and the arm can operate at the same time without holding up the loop times. </p>
        <div className="flex flex-row pl-16">
            <div className="flex flex-col">
                <div className="flex flex-row pt-5 items-center">
                    <div>
                        <p className="text-2xl pt-5 font-semibold">Roadrunner</p>
                        <p className="text-xl font-light">In order to take advantage of the Mecanum wheels on our robot, we use the Roadrunner pathing library to create complex spline paths.</p>
                    </div>
                    <img
                        className=" rounded-md object-contain object-center"
                        src={meepmeep}
                        alt="MeepMeep"
                    />
                </div>
                <div className="flex flex-row pt-5 items-center">
                    <div>
                        <p className="text-2xl pt-5 font-semibold">Low Pass Filter</p>
                        <p className="text-xl font-light">This filter is able to reduce noise in a system. This makes sensor readings more accurate, allowing for repeatable results.</p>
                    </div>
                    <img
                        className=" rounded-md object-fill object-center"
                        src={lowpassfilter}
                        alt="Low Pass Filter"
                    />
                </div>

            </div>
        </div>
    </div>)
    const coding_flow_chart = (<div>
        <div className="flex flex-col items-center ">
            <p className="text-2xl w-4/5 pt-4 text-center font-semibold">State Machine Sample</p>

            <p className="text-xl w-4/5 pt-4 text-left font-light">Below is a segment of code that allows the pixel delivery mechanism to cycle between various stages.</p>
            <br></br>
            <img
                className=" rounded-md object-fill object-center"
                src={statemachine}
                alt="State Machine"
            />
        </div>


    </div>)
    const top = (<div className="grid grid-cols-2 w-2/3 m-auto mt-5 ">
        <div className="text-center m-auto p-5 ">
            <img
                className=" h-96 w-96 rounded-full object-fill object-center"
                src={centerstage}
                alt="CenterStage Logo"
            />

        </div>
        <div className="flex flex-row text-left  p-5 items-center">
            <div>
                <h1 className="text-3xl sm:text-5xl font-semibold">FTC CenterStage</h1>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href="https://github.com/Shyiu/FTCCenterStage">GitHub</a><br></br>
                <a style={transition} className=" text-xl underline text-red-600 hover:text-red-800" href={portfolio} target="_blank" rel="noreferrer">Engineering Portfolio</a>
                <p className="text-l sm:text-2xl">I programmed our robot this season in Java. We earned the 1st Place Inspire Award for being the model FTC Team at our Regional Qualifiers and earned the 2nd Place Innovate Award for our robot's creative design.</p>
            </div>
        </div>
    </div>)
    return (
        <>
            <div className="divide-y divide-black/50 w-3/4 m-auto">
                <FadeInTop html={top}/>
                <div className=" grid-cols-2 pb-10 hidden lg:grid">
                    <FadeIn html={brief_description} left={true} />
                    <FadeIn html={robot_picture} left={false} />
                </div>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={autonomous_section} left={true} />
                    <FadeIn html={autonomous_flow_chart} left={false} />
                </div>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={tele_op_description} left={true} />
                    <FadeIn html={endgame_description} left={false} />
                </div>
                <div className="hidden lg:grid grid-cols-2 pb-10">
                    <FadeIn html={coding_description} left={true} />
                    <FadeIn html={coding_flow_chart} left={false} />
                </div>
            </div>
        </>
    );
}
export default CenterStage;